import React from 'react';
import ReactDOM from 'react-dom';

function ToolbarMenu({ buttonsToolBar = [] }) {
    const [open, setOpen] = React.useState(false);
    const buttonRef = React.useRef(null);
    const menuRef = React.useRef(null);
    const [position, setPosition] = React.useState({ top: 0, left: 0 });

    const toggleMenu = () => {
        if (!open && buttonRef.current) {
            const rect = buttonRef.current.getBoundingClientRect();
            setPosition({
                top: rect.bottom + window.scrollY,
                left: rect.right + window.scrollX
            });
        }
        setOpen(prev => !prev);
    };

    // Fecha ao clicar fora
    React.useEffect(() => {
        function handleClickOutside(event) {
            if (
                menuRef.current &&
                !menuRef.current.contains(event.target) &&
                !buttonRef.current.contains(event.target)
            ) {
                setOpen(false);
            }
        }

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const menu = open && (
        <div
            ref={menuRef}
            style={{
                position: 'absolute',
                top: position.top,
                left: '100%',
                transform: 'translateX(-100%)',
                background: '#fff',
                border: '1px solid #ccc',
                boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                zIndex: 9999,
                padding: 8,
                display: 'flex',
                flexDirection: 'column',
                gap: 6,
                minWidth: 180
            }}
        >
            {buttonsToolBar.map((btn, index) => (
                <div key={index} style={{ display: 'flex' }}>
                    {btn}
                </div>
            ))}
        </div>
    );

    return (
        <>
            <button
                ref={buttonRef}
                onClick={toggleMenu}
                style={{
                    fontSize: 32,
                    padding: '4px 10px',
                    border: 'none',
                    background: 'transparent',
                    cursor: 'pointer'
                }}
            >
                ...
            </button>

            {open && ReactDOM.createPortal(menu, document.body)}
        </>
    );
}

export default ToolbarMenu;